import React, { createContext, useState, useContext } from 'react';

const NotificationContext = createContext();

export const useNotification = () => {
    return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
    // This state will hold the active notification's message and type
    const [notification, setNotification] = useState(null); 

    // Any component can call this function to show a notification
    const showNotification = (message, type = 'success') => {
        setNotification({ message, type });
    };

    // This function will be passed to your Notification component to hide it
    const hideNotification = () => {
        setNotification(null);
    };

    const value = {
        showNotification,
        hideNotification,
        notification // Pass the notification state itself
    };

    return (
        <NotificationContext.Provider value={value}>
            {children}
        </NotificationContext.Provider>
    );
};